export default {
	add_to_your_calendar: "Adicionar ao seu calendário",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explore todo o nosso universo de cursos, vídeos, artigos e arquivos exclusivos.",
	no_events_available_for_the_selected_date: "Não há eventos disponíveis.",
	welcome_to: "Bem-vindo(a) à",
	what_do_you_want_to_learn_today: "O que você deseja aprender hoje?"
}